import { Stack, Typography } from "@mui/material";
import type { FC } from "react";

export const SendTestGuidance: FC = () => (
  <Stack direction="column" spacing={1}>
    <Typography variant="body2" color="text.secondary">
      Send Test will illustrate how your Communication’s layout and design will appear to users. It
      will only show example values for merge tags.
    </Typography>
    <Typography variant="body2" color="text.secondary">
      Use Preview to see genuine data where it exists.
    </Typography>
  </Stack>
);
